<template>
  <div class="simple-list">
    <label>{{ label }}</label>
    <div v-if="!hasDefaultSlot()" class="simple-list-text">
      {{ safeText }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "simple-list",
  props: {
    label: {
      type: String,
      required: true,
    },
    text: {
      type: [Number, String],
    },
  },
  computed: {
    safeText: function () {
      return !this.isEmpty(this.text) ? this.text : "...";
    },
  },
  methods: {
    hasDefaultSlot: function () {
      return !!this.$slots.default;
    },
  },
};
</script>
